import { SCA_NOMINATIONS_URL } from "@util/constant";

/**
 * component to render in nominations tab at How to Nominate page SCA
 */
const NominationsPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 px-5 py-4 font-public-sans"
      data-testid="nominations-page-component"
    >
      <p>
        Submit your nomination for the Best Chief Executive Officer, Best Chief
        Financial Officer or Best Managed Board by completing the online
        nominations form
        <a
          href={SCA_NOMINATIONS_URL}
          target="_blank"
          className="text-blue-175"
          rel="noreferrer"
        >
          {" here"}
        </a>
      </p>
      <p>
        All nominations must be submitted by <strong>31 March 2026</strong>.
      </p>
    </div>
  );
};

export default NominationsPage;
